/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Kuse API
 * Habit tracking application API
 * OpenAPI spec version: 2.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateHabitEntryInboundDto,
  CreateHabitInputClass,
  CreateSubscriptionInputClass,
  CreateSubscriptionOutboundClass,
  DailyStatisticsClass,
  ErrorResponseClass,
  GetConnectedUserOutboundDtoClass,
  GetStreakStatisticsOutboundDto,
  HabitClass,
  HabitEntryClass,
  HabitStatisticsClass,
  HealthResponseClass,
  LogoutResponseClass,
  SignInInboundDtoClass,
  SignInOutboundDtoClass,
  SignUpInboundDtoClass,
  SignUpOutboundDtoClass,
  SubscriptionClass,
  UpdateHabitEntryInboundDto,
  UpdateHabitInputClass,
  UpdateUserPreferencesInboundDtoClass,
  UpdateUserPreferencesOutboundDtoClass
} from './model';

import { customInstance } from '../config/network';
/**
 * @summary User login
 */
export const signIn = (
    signInInboundDtoClass: SignInInboundDtoClass,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SignInOutboundDtoClass>(
      {url: `/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signInInboundDtoClass, signal
    },
      );
    }
  


export const getSignInMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SignInInboundDtoClass}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SignInInboundDtoClass}, TContext> => {

const mutationKey = ['signIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signIn>>, {data: SignInInboundDtoClass}> = (props) => {
          const {data} = props ?? {};

          return  signIn(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignInMutationResult = NonNullable<Awaited<ReturnType<typeof signIn>>>
    export type SignInMutationBody = SignInInboundDtoClass
    export type SignInMutationError = void

    /**
 * @summary User login
 */
export const useSignIn = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signIn>>, TError,{data: SignInInboundDtoClass}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signIn>>,
        TError,
        {data: SignInInboundDtoClass},
        TContext
      > => {

      const mutationOptions = getSignInMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary User registration
 */
export const signUp = (
    signUpInboundDtoClass: SignUpInboundDtoClass,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SignUpOutboundDtoClass>(
      {url: `/auth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signUpInboundDtoClass, signal
    },
      );
    }
  


export const getSignUpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signUp>>, TError,{data: SignUpInboundDtoClass}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signUp>>, TError,{data: SignUpInboundDtoClass}, TContext> => {

const mutationKey = ['signUp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signUp>>, {data: SignUpInboundDtoClass}> = (props) => {
          const {data} = props ?? {};

          return  signUp(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignUpMutationResult = NonNullable<Awaited<ReturnType<typeof signUp>>>
    export type SignUpMutationBody = SignUpInboundDtoClass
    export type SignUpMutationError = void

    /**
 * @summary User registration
 */
export const useSignUp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signUp>>, TError,{data: SignUpInboundDtoClass}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signUp>>,
        TError,
        {data: SignUpInboundDtoClass},
        TContext
      > => {

      const mutationOptions = getSignUpMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get current user profile
 */
export const getProfile = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetConnectedUserOutboundDtoClass>(
      {url: `/auth/me`, method: 'GET', signal
    },
      );
    }
  

export const getGetProfileQueryKey = () => {
    return [`/auth/me`] as const;
    }

    
export const getGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProfile>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({ signal }) => getProfile(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProfile>>>
export type GetProfileQueryError = void


export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfile>>,
          TError,
          Awaited<ReturnType<typeof getProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user profile
 */

export function useGetProfile<TData = Awaited<ReturnType<typeof getProfile>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update user preferences
 */
export const updateUserPreferences = (
    updateUserPreferencesInboundDtoClass: UpdateUserPreferencesInboundDtoClass,
 ) => {
      
      
      return customInstance<UpdateUserPreferencesOutboundDtoClass>(
      {url: `/auth/me/preferences`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserPreferencesInboundDtoClass
    },
      );
    }
  


export const getUpdateUserPreferencesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPreferences>>, TError,{data: UpdateUserPreferencesInboundDtoClass}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUserPreferences>>, TError,{data: UpdateUserPreferencesInboundDtoClass}, TContext> => {

const mutationKey = ['updateUserPreferences'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserPreferences>>, {data: UpdateUserPreferencesInboundDtoClass}> = (props) => {
          const {data} = props ?? {};

          return  updateUserPreferences(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserPreferences>>>
    export type UpdateUserPreferencesMutationBody = UpdateUserPreferencesInboundDtoClass
    export type UpdateUserPreferencesMutationError = void

    /**
 * @summary Update user preferences
 */
export const useUpdateUserPreferences = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserPreferences>>, TError,{data: UpdateUserPreferencesInboundDtoClass}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserPreferences>>,
        TError,
        {data: UpdateUserPreferencesInboundDtoClass},
        TContext
      > => {

      const mutationOptions = getUpdateUserPreferencesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary User logout
 */
export const signOut = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<LogoutResponseClass>(
      {url: `/auth/logout`, method: 'POST', signal
    },
      );
    }
  


export const getSignOutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext> => {

const mutationKey = ['signOut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signOut>>, void> = () => {
          

          return  signOut()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SignOutMutationResult = NonNullable<Awaited<ReturnType<typeof signOut>>>
    
    export type SignOutMutationError = unknown

    /**
 * @summary User logout
 */
export const useSignOut = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signOut>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSignOutMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get user habits with entries
 */
export const getUserHabits = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<HabitClass[]>(
      {url: `/habits`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserHabitsQueryKey = () => {
    return [`/habits`] as const;
    }

    
export const getGetUserHabitsQueryOptions = <TData = Awaited<ReturnType<typeof getUserHabits>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHabits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserHabitsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserHabits>>> = ({ signal }) => getUserHabits(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserHabits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserHabitsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserHabits>>>
export type GetUserHabitsQueryError = unknown


export function useGetUserHabits<TData = Awaited<ReturnType<typeof getUserHabits>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHabits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserHabits>>,
          TError,
          Awaited<ReturnType<typeof getUserHabits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserHabits<TData = Awaited<ReturnType<typeof getUserHabits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHabits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserHabits>>,
          TError,
          Awaited<ReturnType<typeof getUserHabits>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserHabits<TData = Awaited<ReturnType<typeof getUserHabits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHabits>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user habits with entries
 */

export function useGetUserHabits<TData = Awaited<ReturnType<typeof getUserHabits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHabits>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserHabitsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new habit
 */
export const createHabit = (
    createHabitInputClass: CreateHabitInputClass,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HabitClass>(
      {url: `/habits`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createHabitInputClass, signal
    },
      );
    }
  


export const getCreateHabitMutationOptions = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHabit>>, TError,{data: CreateHabitInputClass}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHabit>>, TError,{data: CreateHabitInputClass}, TContext> => {

const mutationKey = ['createHabit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHabit>>, {data: CreateHabitInputClass}> = (props) => {
          const {data} = props ?? {};

          return  createHabit(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateHabitMutationResult = NonNullable<Awaited<ReturnType<typeof createHabit>>>
    export type CreateHabitMutationBody = CreateHabitInputClass
    export type CreateHabitMutationError = ErrorResponseClass

    /**
 * @summary Create a new habit
 */
export const useCreateHabit = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHabit>>, TError,{data: CreateHabitInputClass}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createHabit>>,
        TError,
        {data: CreateHabitInputClass},
        TContext
      > => {

      const mutationOptions = getCreateHabitMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get habit statistics
 */
export const getHabitStatistics = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<HabitStatisticsClass>(
      {url: `/habits/statistics`, method: 'GET', signal
    },
      );
    }
  

export const getGetHabitStatisticsQueryKey = () => {
    return [`/habits/statistics`] as const;
    }

    
export const getGetHabitStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getHabitStatistics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitStatistics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHabitStatisticsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHabitStatistics>>> = ({ signal }) => getHabitStatistics(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHabitStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHabitStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getHabitStatistics>>>
export type GetHabitStatisticsQueryError = unknown


export function useGetHabitStatistics<TData = Awaited<ReturnType<typeof getHabitStatistics>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHabitStatistics>>,
          TError,
          Awaited<ReturnType<typeof getHabitStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHabitStatistics<TData = Awaited<ReturnType<typeof getHabitStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHabitStatistics>>,
          TError,
          Awaited<ReturnType<typeof getHabitStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHabitStatistics<TData = Awaited<ReturnType<typeof getHabitStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get habit statistics
 */

export function useGetHabitStatistics<TData = Awaited<ReturnType<typeof getHabitStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHabitStatisticsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get user streak statistics
 */
export const getStreakStatistics = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetStreakStatisticsOutboundDto>(
      {url: `/habits/streaks`, method: 'GET', signal
    },
      );
    }
  

export const getGetStreakStatisticsQueryKey = () => {
    return [`/habits/streaks`] as const;
    }

    
export const getGetStreakStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getStreakStatistics>>, TError = ErrorResponseClass>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreakStatistics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreakStatisticsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreakStatistics>>> = ({ signal }) => getStreakStatistics(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreakStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreakStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getStreakStatistics>>>
export type GetStreakStatisticsQueryError = ErrorResponseClass


export function useGetStreakStatistics<TData = Awaited<ReturnType<typeof getStreakStatistics>>, TError = ErrorResponseClass>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreakStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreakStatistics>>,
          TError,
          Awaited<ReturnType<typeof getStreakStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreakStatistics<TData = Awaited<ReturnType<typeof getStreakStatistics>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreakStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreakStatistics>>,
          TError,
          Awaited<ReturnType<typeof getStreakStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreakStatistics<TData = Awaited<ReturnType<typeof getStreakStatistics>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreakStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user streak statistics
 */

export function useGetStreakStatistics<TData = Awaited<ReturnType<typeof getStreakStatistics>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreakStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreakStatisticsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get daily habit statistics
 */
export const getDailyStatistics = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<DailyStatisticsClass>(
      {url: `/habits/daily`, method: 'GET', signal
    },
      );
    }
  

export const getGetDailyStatisticsQueryKey = () => {
    return [`/habits/daily`] as const;
    }

    
export const getGetDailyStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getDailyStatistics>>, TError = ErrorResponseClass>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailyStatistics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDailyStatisticsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyStatistics>>> = ({ signal }) => getDailyStatistics(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDailyStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDailyStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getDailyStatistics>>>
export type GetDailyStatisticsQueryError = ErrorResponseClass


export function useGetDailyStatistics<TData = Awaited<ReturnType<typeof getDailyStatistics>>, TError = ErrorResponseClass>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailyStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyStatistics>>,
          TError,
          Awaited<ReturnType<typeof getDailyStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDailyStatistics<TData = Awaited<ReturnType<typeof getDailyStatistics>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailyStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyStatistics>>,
          TError,
          Awaited<ReturnType<typeof getDailyStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDailyStatistics<TData = Awaited<ReturnType<typeof getDailyStatistics>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailyStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get daily habit statistics
 */

export function useGetDailyStatistics<TData = Awaited<ReturnType<typeof getDailyStatistics>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDailyStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDailyStatisticsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get habit by ID
 */
export const getHabitById = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HabitClass>(
      {url: `/habits/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetHabitByIdQueryKey = (id: string,) => {
    return [`/habits/${id}`] as const;
    }

    
export const getGetHabitByIdQueryOptions = <TData = Awaited<ReturnType<typeof getHabitById>>, TError = ErrorResponseClass>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHabitByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHabitById>>> = ({ signal }) => getHabitById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHabitById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHabitByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getHabitById>>>
export type GetHabitByIdQueryError = ErrorResponseClass


export function useGetHabitById<TData = Awaited<ReturnType<typeof getHabitById>>, TError = ErrorResponseClass>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHabitById>>,
          TError,
          Awaited<ReturnType<typeof getHabitById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHabitById<TData = Awaited<ReturnType<typeof getHabitById>>, TError = ErrorResponseClass>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHabitById>>,
          TError,
          Awaited<ReturnType<typeof getHabitById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHabitById<TData = Awaited<ReturnType<typeof getHabitById>>, TError = ErrorResponseClass>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get habit by ID
 */

export function useGetHabitById<TData = Awaited<ReturnType<typeof getHabitById>>, TError = ErrorResponseClass>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHabitByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a habit
 */
export const deleteHabit = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/habits/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteHabitMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHabit>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteHabit>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHabit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHabit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHabit(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteHabitMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHabit>>>
    
    export type DeleteHabitMutationError = void

    /**
 * @summary Delete a habit
 */
export const useDeleteHabit = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHabit>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteHabit>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteHabitMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Update a habit
 */
export const updateHabit = (
    id: string,
    updateHabitInputClass: UpdateHabitInputClass,
 ) => {
      
      
      return customInstance<HabitClass>(
      {url: `/habits/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateHabitInputClass
    },
      );
    }
  


export const getUpdateHabitMutationOptions = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHabit>>, TError,{id: string;data: UpdateHabitInputClass}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHabit>>, TError,{id: string;data: UpdateHabitInputClass}, TContext> => {

const mutationKey = ['updateHabit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHabit>>, {id: string;data: UpdateHabitInputClass}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHabit(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateHabitMutationResult = NonNullable<Awaited<ReturnType<typeof updateHabit>>>
    export type UpdateHabitMutationBody = UpdateHabitInputClass
    export type UpdateHabitMutationError = ErrorResponseClass

    /**
 * @summary Update a habit
 */
export const useUpdateHabit = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHabit>>, TError,{id: string;data: UpdateHabitInputClass}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateHabit>>,
        TError,
        {id: string;data: UpdateHabitInputClass},
        TContext
      > => {

      const mutationOptions = getUpdateHabitMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Health check endpoint
 */
export const getHealth = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<HealthResponseClass>(
      {url: `/health`, method: 'GET', signal
    },
      );
    }
  

export const getGetHealthQueryKey = () => {
    return [`/health`] as const;
    }

    
export const getGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthQueryError = unknown


export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health check endpoint
 */

export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHealthQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a new subscription
 */
export const createSubscription = (
    createSubscriptionInputClass: CreateSubscriptionInputClass,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateSubscriptionOutboundClass>(
      {url: `/subscriptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSubscriptionInputClass, signal
    },
      );
    }
  


export const getCreateSubscriptionMutationOptions = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscription>>, TError,{data: CreateSubscriptionInputClass}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSubscription>>, TError,{data: CreateSubscriptionInputClass}, TContext> => {

const mutationKey = ['createSubscription'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscription>>, {data: CreateSubscriptionInputClass}> = (props) => {
          const {data} = props ?? {};

          return  createSubscription(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscription>>>
    export type CreateSubscriptionMutationBody = CreateSubscriptionInputClass
    export type CreateSubscriptionMutationError = ErrorResponseClass

    /**
 * @summary Create a new subscription
 */
export const useCreateSubscription = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscription>>, TError,{data: CreateSubscriptionInputClass}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSubscription>>,
        TError,
        {data: CreateSubscriptionInputClass},
        TContext
      > => {

      const mutationOptions = getCreateSubscriptionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get current user subscription
 */
export const getUserSubscription = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SubscriptionClass>(
      {url: `/subscriptions`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserSubscriptionQueryKey = () => {
    return [`/subscriptions`] as const;
    }

    
export const getGetUserSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getUserSubscription>>, TError = ErrorResponseClass>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSubscription>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSubscriptionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSubscription>>> = ({ signal }) => getUserSubscription(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSubscription>>>
export type GetUserSubscriptionQueryError = ErrorResponseClass


export function useGetUserSubscription<TData = Awaited<ReturnType<typeof getUserSubscription>>, TError = ErrorResponseClass>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSubscription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSubscription>>,
          TError,
          Awaited<ReturnType<typeof getUserSubscription>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSubscription<TData = Awaited<ReturnType<typeof getUserSubscription>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSubscription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSubscription>>,
          TError,
          Awaited<ReturnType<typeof getUserSubscription>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSubscription<TData = Awaited<ReturnType<typeof getUserSubscription>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSubscription>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user subscription
 */

export function useGetUserSubscription<TData = Awaited<ReturnType<typeof getUserSubscription>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSubscription>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Cancel current user subscription
 */
export const cancelSubscription = (
    
 ) => {
      
      
      return customInstance<void>(
      {url: `/subscriptions`, method: 'DELETE'
    },
      );
    }
  


export const getCancelSubscriptionMutationOptions = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,void, TContext> => {

const mutationKey = ['cancelSubscription'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSubscription>>, void> = () => {
          

          return  cancelSubscription()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSubscription>>>
    
    export type CancelSubscriptionMutationError = ErrorResponseClass

    /**
 * @summary Cancel current user subscription
 */
export const useCancelSubscription = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelSubscription>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCancelSubscriptionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Create a new habit entry
 */
export const createHabitEntry = (
    createHabitEntryInboundDto: CreateHabitEntryInboundDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HabitEntryClass>(
      {url: `/habit-entries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createHabitEntryInboundDto, signal
    },
      );
    }
  


export const getCreateHabitEntryMutationOptions = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHabitEntry>>, TError,{data: CreateHabitEntryInboundDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHabitEntry>>, TError,{data: CreateHabitEntryInboundDto}, TContext> => {

const mutationKey = ['createHabitEntry'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHabitEntry>>, {data: CreateHabitEntryInboundDto}> = (props) => {
          const {data} = props ?? {};

          return  createHabitEntry(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateHabitEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createHabitEntry>>>
    export type CreateHabitEntryMutationBody = CreateHabitEntryInboundDto
    export type CreateHabitEntryMutationError = ErrorResponseClass

    /**
 * @summary Create a new habit entry
 */
export const useCreateHabitEntry = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHabitEntry>>, TError,{data: CreateHabitEntryInboundDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createHabitEntry>>,
        TError,
        {data: CreateHabitEntryInboundDto},
        TContext
      > => {

      const mutationOptions = getCreateHabitEntryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get habit entry by ID
 */
export const getHabitEntryById = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HabitEntryClass>(
      {url: `/habit-entries/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetHabitEntryByIdQueryKey = (id: string,) => {
    return [`/habit-entries/${id}`] as const;
    }

    
export const getGetHabitEntryByIdQueryOptions = <TData = Awaited<ReturnType<typeof getHabitEntryById>>, TError = ErrorResponseClass>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntryById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHabitEntryByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHabitEntryById>>> = ({ signal }) => getHabitEntryById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHabitEntryById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHabitEntryByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getHabitEntryById>>>
export type GetHabitEntryByIdQueryError = ErrorResponseClass


export function useGetHabitEntryById<TData = Awaited<ReturnType<typeof getHabitEntryById>>, TError = ErrorResponseClass>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntryById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHabitEntryById>>,
          TError,
          Awaited<ReturnType<typeof getHabitEntryById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHabitEntryById<TData = Awaited<ReturnType<typeof getHabitEntryById>>, TError = ErrorResponseClass>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntryById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHabitEntryById>>,
          TError,
          Awaited<ReturnType<typeof getHabitEntryById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHabitEntryById<TData = Awaited<ReturnType<typeof getHabitEntryById>>, TError = ErrorResponseClass>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntryById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get habit entry by ID
 */

export function useGetHabitEntryById<TData = Awaited<ReturnType<typeof getHabitEntryById>>, TError = ErrorResponseClass>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntryById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHabitEntryByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update habit entry
 */
export const updateHabitEntry = (
    id: string,
    updateHabitEntryInboundDto: UpdateHabitEntryInboundDto,
 ) => {
      
      
      return customInstance<HabitEntryClass>(
      {url: `/habit-entries/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateHabitEntryInboundDto
    },
      );
    }
  


export const getUpdateHabitEntryMutationOptions = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHabitEntry>>, TError,{id: string;data: UpdateHabitEntryInboundDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHabitEntry>>, TError,{id: string;data: UpdateHabitEntryInboundDto}, TContext> => {

const mutationKey = ['updateHabitEntry'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHabitEntry>>, {id: string;data: UpdateHabitEntryInboundDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateHabitEntry(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateHabitEntryMutationResult = NonNullable<Awaited<ReturnType<typeof updateHabitEntry>>>
    export type UpdateHabitEntryMutationBody = UpdateHabitEntryInboundDto
    export type UpdateHabitEntryMutationError = ErrorResponseClass

    /**
 * @summary Update habit entry
 */
export const useUpdateHabitEntry = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHabitEntry>>, TError,{id: string;data: UpdateHabitEntryInboundDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateHabitEntry>>,
        TError,
        {id: string;data: UpdateHabitEntryInboundDto},
        TContext
      > => {

      const mutationOptions = getUpdateHabitEntryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Delete habit entry
 */
export const deleteHabitEntry = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/habit-entries/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteHabitEntryMutationOptions = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHabitEntry>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteHabitEntry>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteHabitEntry'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHabitEntry>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHabitEntry(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteHabitEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHabitEntry>>>
    
    export type DeleteHabitEntryMutationError = ErrorResponseClass

    /**
 * @summary Delete habit entry
 */
export const useDeleteHabitEntry = <TError = ErrorResponseClass,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHabitEntry>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteHabitEntry>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteHabitEntryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary Get habit entries by habit ID
 */
export const getHabitEntriesByHabitId = (
    habitId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HabitEntryClass[]>(
      {url: `/habit-entries/habit/${habitId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetHabitEntriesByHabitIdQueryKey = (habitId: string,) => {
    return [`/habit-entries/habit/${habitId}`] as const;
    }

    
export const getGetHabitEntriesByHabitIdQueryOptions = <TData = Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError = ErrorResponseClass>(habitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHabitEntriesByHabitIdQueryKey(habitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHabitEntriesByHabitId>>> = ({ signal }) => getHabitEntriesByHabitId(habitId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(habitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHabitEntriesByHabitIdQueryResult = NonNullable<Awaited<ReturnType<typeof getHabitEntriesByHabitId>>>
export type GetHabitEntriesByHabitIdQueryError = ErrorResponseClass


export function useGetHabitEntriesByHabitId<TData = Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError = ErrorResponseClass>(
 habitId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHabitEntriesByHabitId>>,
          TError,
          Awaited<ReturnType<typeof getHabitEntriesByHabitId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHabitEntriesByHabitId<TData = Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError = ErrorResponseClass>(
 habitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHabitEntriesByHabitId>>,
          TError,
          Awaited<ReturnType<typeof getHabitEntriesByHabitId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHabitEntriesByHabitId<TData = Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError = ErrorResponseClass>(
 habitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get habit entries by habit ID
 */

export function useGetHabitEntriesByHabitId<TData = Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError = ErrorResponseClass>(
 habitId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHabitEntriesByHabitId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHabitEntriesByHabitIdQueryOptions(habitId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get all habit entries for current user
 */
export const getAllHabitEntriesForUser = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<HabitEntryClass[]>(
      {url: `/habit-entries/user/all`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllHabitEntriesForUserQueryKey = () => {
    return [`/habit-entries/user/all`] as const;
    }

    
export const getGetAllHabitEntriesForUserQueryOptions = <TData = Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError = ErrorResponseClass>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllHabitEntriesForUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllHabitEntriesForUser>>> = ({ signal }) => getAllHabitEntriesForUser(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllHabitEntriesForUserQueryResult = NonNullable<Awaited<ReturnType<typeof getAllHabitEntriesForUser>>>
export type GetAllHabitEntriesForUserQueryError = ErrorResponseClass


export function useGetAllHabitEntriesForUser<TData = Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError = ErrorResponseClass>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllHabitEntriesForUser>>,
          TError,
          Awaited<ReturnType<typeof getAllHabitEntriesForUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllHabitEntriesForUser<TData = Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllHabitEntriesForUser>>,
          TError,
          Awaited<ReturnType<typeof getAllHabitEntriesForUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllHabitEntriesForUser<TData = Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all habit entries for current user
 */

export function useGetAllHabitEntriesForUser<TData = Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError = ErrorResponseClass>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllHabitEntriesForUser>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllHabitEntriesForUserQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
